import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import BackButton from './BackButton';

const AddButtonPicker = () => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.back.name]: () => {
      return (
        <BackButton />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AddButtonPicker;
